import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InParens',
  props: {
    visible: { type: Boolean },
    baseClass: {},
    hoverClass: {}
  },
  setup(__props: any) {

const props = __props;

const hoverLeft = ref(false);
const hoverRight = ref(false);
const hover = computed(() => hoverLeft.value || hoverRight.value);

const classes = computed(() =>
  hover.value
    ? props.hoverClass ?? "paren paren-hover"
    : props.baseClass ?? "paren"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(classes.value),
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hoverLeft.value = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverLeft.value = false))
        }, " ( ", 34))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(classes.value),
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (hoverRight.value = true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (hoverRight.value = false))
        }, " ) ", 34))
      : _createCommentVNode("", true)
  ], 64))
}
}

})